export default {"src":"/_next/static/media/done.03dc39b4.svg","height":224,"width":215,"blurWidth":0,"blurHeight":0};